import { User } from "oidc-client-ts";

import { logger } from "common/utilities/logger";

export const parseOidcUser = (storageString: string) => {
  try {
    return User.fromStorageString(storageString);
  } catch (error) {
    logger.error("[createUserFromStorageString] Failed to create user from storage string", error);
    return undefined;
  }
};
